<!-- @format -->
<script lang="ts">
  import type { ManageAPI } from "~/manage-api/types";
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import OfferCardImage from "./OfferCardImage.svelte";
  import OfferView from "~/components/statistics/OfferView.svelte";

  export let offer: ManageAPI.Offer;
  export let request_store_key: StoresKey;
  export let isInCarousel = true;

  const { T, reverse_router, stores } = getStoresContext(request_store_key);
  $: t = $T;
  
  $: href = $reverse_router.routeOffer(offer);
  $: storeLogo = $stores?.find((store) => store.id === offer.store?.id)?.logoURL || "";
  $: id = offer.id;
</script>

<OfferView {id} on:focusOffer>
  <div class="offer-card">
    <a {href} class="offer-card-link">
      <div class="image-container">
        <OfferCardImage {offer} {storeLogo} />
      </div>
      <div class="content-wrapper">
        <div class="store-name text-purple fw-bold">{offer.store?.name}</div>
        <p class="offer-description">
          {offer.title}
          {offer.description1}
          {offer.description2}
        </p>
        {#if offer.lowestPriceInXDays}
          <p class="omnibus-field">
            {t`lowestPrice30`}: {offer.lowestPriceInXDays}
          </p>
        {/if}
        {#if !isInCarousel && offer.longDescription}
          <p class="long-description">{offer.longDescription}</p>
        {/if}
      </div>
    </a>
  </div>
</OfferView>

<style lang="scss">
  .offer-card {
    height: 100%;
  }

  .offer-card-link {
    display: flex;
    flex-direction: column;
    height: 100%;
    text-decoration: none;
    color: inherit;

    &:hover {
      .store-name {
        text-decoration: underline;
      }
    }
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .store-name {
    text-align: center;
    font-size: 16px;
    margin-top: 10px;
    transition: text-decoration 0.2s ease;
  }

  p {
    text-align: center;
  }

  .long-description {
    font-size: 14px;
    line-height: 1.5;
    margin-top: 1rem;
    color: var(--color-text);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
</style>
